import ubicacion_model from '@/shared/models/ubicacion_model';

export const inventory_movement_series_model = {
  Codigo: null,
  CodigoItem: null,
  CantidadSeries: 1,
  NumeroSerie: '',
  Cantidad1: null,
  CodigoUnidadMedida1: null,
  Cantidad2: null,
  CodigoUnidadMedida2: null,
  Cantidad3: null,
  CodigoUnidadMedida3: null,
  CodigoUbicacion: null,
  Ubicacion: { ...ubicacion_model },
  UbicacionDestino: { ...ubicacion_model },
};
